import { render } from "./UpgraderGame.vue?vue&type=template&id=19c11625&scoped=true"
import script from "./UpgraderGame.vue?vue&type=script&lang=js"
export * from "./UpgraderGame.vue?vue&type=script&lang=js"

import "./UpgraderGame.vue?vue&type=style&index=0&id=19c11625&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c11625"]])

export default __exports__